// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.designSystem-components-dateRange-DateRangeTimePicker-module-root {
	--rdp-cell-size: 40px;
	/* Size of the day cells. */
	--rdp-caption-font-size: 18px;
	/* Font size for the caption labels. */
	--rdp-accent-color: #0000ff;
	/* Accent color for the background of selected days. */
	--rdp-background-color: #e7edff;
	/* Background color for the hovered/focused elements. */
	--rdp-accent-color-dark: #3003e1;
	/* Accent color for the background of selected days (to use in dark-mode). */
	--rdp-background-color-dark: #180270;
	/* Background color for the hovered/focused elements (to use in dark-mode). */
	--rdp-outline: 2px solid var(--rdp-accent-color);
	/* Outline border for focused elements */
	--rdp-outline-selected: 3px solid var(--rdp-accent-color);
	/* Outline border for focused _and_ selected elements */
	--rdp-selected-color: #fff;
	/* Color of selected day text */

	margin: 1em;
}

/* Hide elements for devices that are not screen readers */
.designSystem-components-dateRange-DateRangeTimePicker-module-vhidden {
	position: absolute !important;
	width: 1px !important;
	height: 1px !important;
	padding: 0 !important;
	overflow: hidden !important;
	clip: rect(1px, 1px, 1px, 1px) !important;
	border: 0 !important;
}
.designSystem-components-dateRange-DateRangeTimePicker-module-vhidden {
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	padding: 0;
	margin: 0;
	background: transparent;
	border: 0;
	-moz-appearance: none;
	-webkit-appearance: none;
	appearance: none;
	top: 0;
}

/* Buttons */
.designSystem-components-dateRange-DateRangeTimePicker-module-button_reset {
	appearance: none;
	position: relative;
	margin: 0;
	padding: 0;
	cursor: default;
	color: inherit;
	background: none;
	font: inherit;

	-moz-appearance: none;
	-webkit-appearance: none;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-button_reset.designSystem-components-dateRange-DateRangeTimePicker-module-focus-visible {
	/* Make sure to reset outline only when :focus-visible is supported */
	outline: none;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-button_reset:focus-visible {
	/* Make sure to reset outline only when :focus-visible is supported */
	outline: none;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-button {
	border: 2px solid transparent;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-button[disabled]:not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected) {
	opacity: 0.25;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-button:not([disabled]) {
	cursor: pointer;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-button.designSystem-components-dateRange-DateRangeTimePicker-module-focus-visible:not([disabled]) {
	color: inherit;
	background-color: var(--rdp-background-color);
	border: var(--rdp-outline);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-button:focus-visible:not([disabled]) {
	color: inherit;
	background-color: var(--rdp-background-color);
	border: var(--rdp-outline);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-button:hover:not([disabled]):not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected) {
	background-color: var(--rdp-background-color);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-months {
	display: -ms-flexbox;
	display: flex;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-month {
	margin: 0 1em;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-month:first-child {
	margin-left: 0;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-month:last-child {
	margin-right: 0;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-table {
	margin: 0;
	max-width: calc(var(--rdp-cell-size) * 7);
	border-collapse: collapse;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-with_weeknumber .designSystem-components-dateRange-DateRangeTimePicker-module-table {
	max-width: calc(var(--rdp-cell-size) * 8);
	border-collapse: collapse;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-caption {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-align: center;
	    align-items: center;
	-ms-flex-pack: justify;
	    justify-content: space-between;
	padding: 0;
	text-align: left;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-multiple_months .designSystem-components-dateRange-DateRangeTimePicker-module-caption {
	position: relative;
	display: block;
	text-align: center;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-caption_dropdowns {
	position: relative;
	display: -ms-inline-flexbox;
	display: inline-flex;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-caption_label {
	position: relative;
	z-index: 1;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-ms-flex-align: center;
	    align-items: center;
	margin: 0;
	padding: 0 0.25em;
	white-space: nowrap;
	color: currentColor;
	border: 0;
	border: 2px solid transparent;
	font-family: inherit;
	font-size: var(--rdp-caption-font-size);
	font-weight: bold;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-nav {
	white-space: nowrap;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-multiple_months .designSystem-components-dateRange-DateRangeTimePicker-module-caption_start .designSystem-components-dateRange-DateRangeTimePicker-module-nav {
	position: absolute;
	top: 50%;
	left: 0;
	-webkit-transform: translateY(-50%);
	        transform: translateY(-50%);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-multiple_months .designSystem-components-dateRange-DateRangeTimePicker-module-caption_end .designSystem-components-dateRange-DateRangeTimePicker-module-nav {
	position: absolute;
	top: 50%;
	right: 0;
	-webkit-transform: translateY(-50%);
	        transform: translateY(-50%);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-nav_button {
	display: -ms-inline-flexbox;
	display: inline-flex;
	-ms-flex-align: center;
	    align-items: center;
	-ms-flex-pack: center;
	    justify-content: center;
	width: var(--rdp-cell-size);
	height: var(--rdp-cell-size);
	padding: 0.25em;
	border-radius: 100%;
}

/* ---------- */
/* Dropdowns  */
/* ---------- */

.designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_year,
.designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_month {
	position: relative;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-ms-flex-align: center;
	    align-items: center;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-dropdown {
	-webkit-appearance: none;
	   -moz-appearance: none;
	        appearance: none;
	position: absolute;
	z-index: 2;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	margin: 0;
	padding: 0;
	cursor: inherit;
	opacity: 0;
	border: none;
	background-color: transparent;
	font-family: inherit;
	font-size: inherit;
	line-height: inherit;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-dropdown[disabled] {
	opacity: 1;
	opacity: initial;
	color: inherit;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-dropdown.designSystem-components-dateRange-DateRangeTimePicker-module-focus-visible:not([disabled])+.designSystem-components-dateRange-DateRangeTimePicker-module-caption_label {
	background-color: var(--rdp-background-color);
	border: var(--rdp-outline);
	border-radius: 6px;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-dropdown:focus-visible:not([disabled])+.designSystem-components-dateRange-DateRangeTimePicker-module-caption_label {
	background-color: var(--rdp-background-color);
	border: var(--rdp-outline);
	border-radius: 6px;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_icon {
	margin: 0 0 0 5px;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-head {
	border: 0;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-head_row,
.designSystem-components-dateRange-DateRangeTimePicker-module-row {
	height: 100%;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-head_cell {
	vertical-align: middle;
	font-size: 0.75em;
	font-weight: 700;
	text-align: center;
	height: 100%;
	height: var(--rdp-cell-size);
	padding: 0;
	text-transform: uppercase;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-tbody {
	border: 0;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-tfoot {
	margin: 0.5em;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-cell {
	width: var(--rdp-cell-size);
	height: 100%;
	height: var(--rdp-cell-size);
	padding: 0;
	text-align: center;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-weeknumber {
	font-size: 0.75em;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-weeknumber,
.designSystem-components-dateRange-DateRangeTimePicker-module-day {
	display: -ms-flexbox;
	display: flex;
	overflow: hidden;
	-ms-flex-align: center;
	    align-items: center;
	-ms-flex-pack: center;
	    justify-content: center;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	width: var(--rdp-cell-size);
	max-width: var(--rdp-cell-size);
	height: var(--rdp-cell-size);
	margin: 0;
	border: 2px solid transparent;
	border-radius: 100%;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_today:not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_outside) {
	font-weight: bold;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected,
.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected.designSystem-components-dateRange-DateRangeTimePicker-module-focus-visible,
.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected:hover {
	color: var(--rdp-selected-color);
	opacity: 1;
	background-color: var(--rdp-accent-color);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected,
.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected:focus-visible,
.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected:hover {
	color: var(--rdp-selected-color);
	opacity: 1;
	background-color: var(--rdp-accent-color);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_outside {
	opacity: 0.5;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected.designSystem-components-dateRange-DateRangeTimePicker-module-focus-visible {
	/* Since the background is the same use again the outline */
	outline: var(--rdp-outline);
	outline-offset: 2px;
	z-index: 1;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_selected:focus-visible {
	/* Since the background is the same use again the outline */
	outline: var(--rdp-outline);
	outline-offset: 2px;
	z-index: 1;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-root:not([dir='rtl']) .designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start:not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-root:not([dir='rtl']) .designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end:not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start) {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-root[dir='rtl'] .designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start:not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end) {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-root[dir='rtl'] .designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end:not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start {
	border-radius: 100%;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_middle {
	border-radius: 0;
}


/* ----------------------- Apply Centric Overrides Below ----------------------------- */
.designSystem-components-dateRange-DateRangeTimePicker-module-root {
	/* override */
	--rdp-cell-size: 40px;
	/* Size of the day cells. */
	--rdp-caption-font-size: 12px;
	/* Font size for the caption labels. */
	--rdp-accent-color: var(--Blue600);
	/* Accent color for the background of selected days. */
	--rdp-background-color: #e7edff;
	/* Background color for the hovered/focused elements. */
	--rdp-accent-color-dark: #3003e1;
	/* Accent color for the background of selected days (to use in dark-mode). */
	--rdp-background-color-dark: #180270;
	/* Background color for the hovered/focused elements (to use in dark-mode). */
	--rdp-outline: 2px solid var(--rdp-accent-color);
	/* Outline border for focused elements */
	--rdp-outline-selected: 3px solid var(--rdp-accent-color);
	/* Outline border for focused _and_ selected elements */
	--rdp-selected-color: #fff;
	/* Color of selected day text */

	margin: 0;

	-webkit-user-select: none;

	   -moz-user-select: none;

	            -ms-user-select: none;

	        user-select: none;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start {
	/* override */
	height: calc(var(--rdp-cell-size) - 4px);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_middle {
	/* override */
	background: var(--Blue50);
	height: calc(var(--rdp-cell-size) - 4px);
	color: var(--PrimaryBlack);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end {
	/* override */
	height: calc(var(--rdp-cell-size) - 4px);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-day_outside {
	/* override */
	opacity: 0.3;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-root:not([dir='rtl']) .designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start:not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end) {
	/* override */
	border-top-left-radius: 20%;
	border-bottom-left-radius: 20%;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-root:not([dir='rtl']) .designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end:not(.designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start) {
	/* override */
	border-top-right-radius: 20%;
	border-bottom-right-radius: 20%;
}

/* give caption horizontal padding */
.designSystem-components-dateRange-DateRangeTimePicker-module-caption {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-align: center;
	    align-items: center;
	-ms-flex-pack: justify;
	    justify-content: space-between;
	padding: 0;
	text-align: left;
	/* override */
	padding: 0 8px;
}

/* make nav buttons smaller */
.designSystem-components-dateRange-DateRangeTimePicker-module-nav {
	white-space: nowrap;
	/* override */
	-webkit-transform: scale(0.5);
	        transform: scale(0.5);
	-webkit-transform-origin: right;
	        transform-origin: right;
}

/* ------------------- Apply style overrides to custom components below -------------- */
.designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsTime {
	cursor: pointer;
	padding-bottom: 2px;
	padding-left: 4px;
	padding-right: 1px;
	padding-top: 2px;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsDynamicDateButtons {
	-ms-flex-pack: start;
	    justify-content: flex-start;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsDynamicDateButtonsSelected {
	background-color: var(--Blue50);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsControlledTextField {
	width: auto;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsNumberOfDaysTextField {
	width: 40px;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsTimeDisabled {
	color: var(--Grey400);
	cursor: no-drop;
}

.designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsTimeBackground {
	background-color: var(--Grey100);
}

.designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsSelectedTime {
	background-color: var(--Blue600);
	border-radius: 3px;
	color: var(--PrimaryWhite);
}`, "",{"version":3,"sources":["webpack://./src/designSystem/components/dateRange/DateRangeTimePicker.module.css"],"names":[],"mappings":"AAAA;CACC,qBAAqB;CACrB,2BAA2B;CAC3B,6BAA6B;CAC7B,sCAAsC;CACtC,2BAA2B;CAC3B,sDAAsD;CACtD,+BAA+B;CAC/B,uDAAuD;CACvD,gCAAgC;CAChC,4EAA4E;CAC5E,oCAAoC;CACpC,6EAA6E;CAC7E,gDAAgD;CAChD,wCAAwC;CACxC,yDAAyD;CACzD,uDAAuD;CACvD,0BAA0B;CAC1B,+BAA+B;;CAE/B,WAAW;AACZ;;AAEA,0DAA0D;AAC1D;CASC,6BAA6B;CAE7B,qBAAqB;CACrB,sBAAsB;CACtB,qBAAqB;CACrB,2BAA2B;CAC3B,yCAAyC;CACzC,oBAAoB;AACrB;AAjBA;CACC,8BAAsB;SAAtB,sBAAsB;CACtB,UAAU;CACV,SAAS;CACT,uBAAuB;CACvB,SAAS;CACT,qBAAqB;CACrB,wBAAwB;CACxB,gBAAgB;CAEhB,MAAM;AAOP;;AAEA,YAAY;AACZ;CACC,gBAAgB;CAChB,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,aAAa;;CAEb,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,qEAAqE;CACrE,aAAa;AACd;;AAHA;CACC,qEAAqE;CACrE,aAAa;AACd;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,6CAA6C;CAC7C,0BAA0B;AAC3B;;AAJA;CACC,cAAc;CACd,6CAA6C;CAC7C,0BAA0B;AAC3B;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,SAAS;CACT,yCAAyC;CACzC,yBAAyB;AAC1B;;AAEA;CACC,yCAAyC;CACzC,yBAAyB;AAC1B;;AAEA;CACC,oBAAa;CAAb,aAAa;CACb,sBAAmB;KAAnB,mBAAmB;CACnB,sBAA8B;KAA9B,8BAA8B;CAC9B,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,2BAAoB;CAApB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,2BAAoB;CAApB,oBAAoB;CACpB,sBAAmB;KAAnB,mBAAmB;CACnB,SAAS;CACT,iBAAiB;CACjB,mBAAmB;CACnB,mBAAmB;CACnB,SAAS;CACT,6BAA6B;CAC7B,oBAAoB;CACpB,uCAAuC;CACvC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,mCAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CACR,mCAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;CACC,2BAAoB;CAApB,oBAAoB;CACpB,sBAAmB;KAAnB,mBAAmB;CACnB,qBAAuB;KAAvB,uBAAuB;CACvB,2BAA2B;CAC3B,4BAA4B;CAC5B,eAAe;CACf,mBAAmB;AACpB;;AAEA,eAAe;AACf,eAAe;AACf,eAAe;;AAEf;;CAEC,kBAAkB;CAClB,2BAAoB;CAApB,oBAAoB;CACpB,sBAAmB;KAAnB,mBAAmB;AACpB;;AAEA;CACC,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;CACV,MAAM;CACN,SAAS;CACT,OAAO;CACP,WAAW;CACX,SAAS;CACT,UAAU;CACV,eAAe;CACf,UAAU;CACV,YAAY;CACZ,6BAA6B;CAC7B,oBAAoB;CACpB,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,UAAc;CAAd,gBAAc;CACd,cAAY;AACb;;AAEA;CACC,6CAA6C;CAC7C,0BAA0B;CAC1B,kBAAkB;AACnB;;AAJA;CACC,6CAA6C;CAC7C,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,SAAS;AACV;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,4BAA4B;CAC5B,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,2BAA2B;CAC3B,YAAY;CACZ,4BAA4B;CAC5B,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;CAEC,oBAAa;CAAb,aAAa;CACb,gBAAgB;CAChB,sBAAmB;KAAnB,mBAAmB;CACnB,qBAAuB;KAAvB,uBAAuB;CACvB,8BAAsB;SAAtB,sBAAsB;CACtB,2BAA2B;CAC3B,+BAA+B;CAC/B,4BAA4B;CAC5B,SAAS;CACT,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;;CAGC,gCAAgC;CAChC,UAAU;CACV,yCAAyC;AAC1C;;AANA;;;CAGC,gCAAgC;CAChC,UAAU;CACV,yCAAyC;AAC1C;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2DAA2D;CAC3D,2BAA2B;CAC3B,mBAAmB;CACnB,UAAU;AACX;;AALA;CACC,2DAA2D;CAC3D,2BAA2B;CAC3B,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;;AAGA,wFAAwF;AACxF;CACC,aAAa;CACb,qBAAqB;CACrB,2BAA2B;CAC3B,6BAA6B;CAC7B,sCAAsC;CACtC,kCAAkC;CAClC,sDAAsD;CACtD,+BAA+B;CAC/B,uDAAuD;CACvD,gCAAgC;CAChC,4EAA4E;CAC5E,oCAAoC;CACpC,6EAA6E;CAC7E,gDAAgD;CAChD,wCAAwC;CACxC,yDAAyD;CACzD,uDAAuD;CACvD,0BAA0B;CAC1B,+BAA+B;;CAE/B,SAAS;;CAET,yBAAiB;;IAAjB,sBAAiB;;aAAjB,qBAAiB;;SAAjB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,wCAAwC;CACxC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;CACb,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;CACC,aAAa;CACb,2BAA2B;CAC3B,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,4BAA4B;CAC5B,+BAA+B;AAChC;;AAEA,oCAAoC;AACpC;CACC,oBAAa;CAAb,aAAa;CACb,sBAAmB;KAAnB,mBAAmB;CACnB,sBAA8B;KAA9B,8BAA8B;CAC9B,UAAU;CACV,gBAAgB;CAChB,aAAa;CACb,cAAc;AACf;;AAEA,6BAA6B;AAC7B;CACC,mBAAmB;CACnB,aAAa;CACb,6BAAqB;SAArB,qBAAqB;CACrB,+BAAuB;SAAvB,uBAAuB;AACxB;;AAEA,wFAAwF;AACxF;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,oBAA2B;KAA3B,2BAA2B;AAC5B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;CAClB,0BAA0B;AAC3B","sourcesContent":[".root {\n\t--rdp-cell-size: 40px;\n\t/* Size of the day cells. */\n\t--rdp-caption-font-size: 18px;\n\t/* Font size for the caption labels. */\n\t--rdp-accent-color: #0000ff;\n\t/* Accent color for the background of selected days. */\n\t--rdp-background-color: #e7edff;\n\t/* Background color for the hovered/focused elements. */\n\t--rdp-accent-color-dark: #3003e1;\n\t/* Accent color for the background of selected days (to use in dark-mode). */\n\t--rdp-background-color-dark: #180270;\n\t/* Background color for the hovered/focused elements (to use in dark-mode). */\n\t--rdp-outline: 2px solid var(--rdp-accent-color);\n\t/* Outline border for focused elements */\n\t--rdp-outline-selected: 3px solid var(--rdp-accent-color);\n\t/* Outline border for focused _and_ selected elements */\n\t--rdp-selected-color: #fff;\n\t/* Color of selected day text */\n\n\tmargin: 1em;\n}\n\n/* Hide elements for devices that are not screen readers */\n.vhidden {\n\tbox-sizing: border-box;\n\tpadding: 0;\n\tmargin: 0;\n\tbackground: transparent;\n\tborder: 0;\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n\tappearance: none;\n\tposition: absolute !important;\n\ttop: 0;\n\twidth: 1px !important;\n\theight: 1px !important;\n\tpadding: 0 !important;\n\toverflow: hidden !important;\n\tclip: rect(1px, 1px, 1px, 1px) !important;\n\tborder: 0 !important;\n}\n\n/* Buttons */\n.button_reset {\n\tappearance: none;\n\tposition: relative;\n\tmargin: 0;\n\tpadding: 0;\n\tcursor: default;\n\tcolor: inherit;\n\tbackground: none;\n\tfont: inherit;\n\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n\n.button_reset:focus-visible {\n\t/* Make sure to reset outline only when :focus-visible is supported */\n\toutline: none;\n}\n\n.button {\n\tborder: 2px solid transparent;\n}\n\n.button[disabled]:not(.day_selected) {\n\topacity: 0.25;\n}\n\n.button:not([disabled]) {\n\tcursor: pointer;\n}\n\n.button:focus-visible:not([disabled]) {\n\tcolor: inherit;\n\tbackground-color: var(--rdp-background-color);\n\tborder: var(--rdp-outline);\n}\n\n.button:hover:not([disabled]):not(.day_selected) {\n\tbackground-color: var(--rdp-background-color);\n}\n\n.months {\n\tdisplay: flex;\n}\n\n.month {\n\tmargin: 0 1em;\n}\n\n.month:first-child {\n\tmargin-left: 0;\n}\n\n.month:last-child {\n\tmargin-right: 0;\n}\n\n.table {\n\tmargin: 0;\n\tmax-width: calc(var(--rdp-cell-size) * 7);\n\tborder-collapse: collapse;\n}\n\n.with_weeknumber .table {\n\tmax-width: calc(var(--rdp-cell-size) * 8);\n\tborder-collapse: collapse;\n}\n\n.caption {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 0;\n\ttext-align: left;\n}\n\n.multiple_months .caption {\n\tposition: relative;\n\tdisplay: block;\n\ttext-align: center;\n}\n\n.caption_dropdowns {\n\tposition: relative;\n\tdisplay: inline-flex;\n}\n\n.caption_label {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tmargin: 0;\n\tpadding: 0 0.25em;\n\twhite-space: nowrap;\n\tcolor: currentColor;\n\tborder: 0;\n\tborder: 2px solid transparent;\n\tfont-family: inherit;\n\tfont-size: var(--rdp-caption-font-size);\n\tfont-weight: bold;\n}\n\n.nav {\n\twhite-space: nowrap;\n}\n\n.multiple_months .caption_start .nav {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\ttransform: translateY(-50%);\n}\n\n.multiple_months .caption_end .nav {\n\tposition: absolute;\n\ttop: 50%;\n\tright: 0;\n\ttransform: translateY(-50%);\n}\n\n.nav_button {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: var(--rdp-cell-size);\n\theight: var(--rdp-cell-size);\n\tpadding: 0.25em;\n\tborder-radius: 100%;\n}\n\n/* ---------- */\n/* Dropdowns  */\n/* ---------- */\n\n.dropdown_year,\n.dropdown_month {\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n}\n\n.dropdown {\n\tappearance: none;\n\tposition: absolute;\n\tz-index: 2;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 100%;\n\tmargin: 0;\n\tpadding: 0;\n\tcursor: inherit;\n\topacity: 0;\n\tborder: none;\n\tbackground-color: transparent;\n\tfont-family: inherit;\n\tfont-size: inherit;\n\tline-height: inherit;\n}\n\n.dropdown[disabled] {\n\topacity: unset;\n\tcolor: unset;\n}\n\n.dropdown:focus-visible:not([disabled])+.caption_label {\n\tbackground-color: var(--rdp-background-color);\n\tborder: var(--rdp-outline);\n\tborder-radius: 6px;\n}\n\n.dropdown_icon {\n\tmargin: 0 0 0 5px;\n}\n\n.head {\n\tborder: 0;\n}\n\n.head_row,\n.row {\n\theight: 100%;\n}\n\n.head_cell {\n\tvertical-align: middle;\n\tfont-size: 0.75em;\n\tfont-weight: 700;\n\ttext-align: center;\n\theight: 100%;\n\theight: var(--rdp-cell-size);\n\tpadding: 0;\n\ttext-transform: uppercase;\n}\n\n.tbody {\n\tborder: 0;\n}\n\n.tfoot {\n\tmargin: 0.5em;\n}\n\n.cell {\n\twidth: var(--rdp-cell-size);\n\theight: 100%;\n\theight: var(--rdp-cell-size);\n\tpadding: 0;\n\ttext-align: center;\n}\n\n.weeknumber {\n\tfont-size: 0.75em;\n}\n\n.weeknumber,\n.day {\n\tdisplay: flex;\n\toverflow: hidden;\n\talign-items: center;\n\tjustify-content: center;\n\tbox-sizing: border-box;\n\twidth: var(--rdp-cell-size);\n\tmax-width: var(--rdp-cell-size);\n\theight: var(--rdp-cell-size);\n\tmargin: 0;\n\tborder: 2px solid transparent;\n\tborder-radius: 100%;\n}\n\n.day_today:not(.day_outside) {\n\tfont-weight: bold;\n}\n\n.day_selected,\n.day_selected:focus-visible,\n.day_selected:hover {\n\tcolor: var(--rdp-selected-color);\n\topacity: 1;\n\tbackground-color: var(--rdp-accent-color);\n}\n\n.day_outside {\n\topacity: 0.5;\n}\n\n.day_selected:focus-visible {\n\t/* Since the background is the same use again the outline */\n\toutline: var(--rdp-outline);\n\toutline-offset: 2px;\n\tz-index: 1;\n}\n\n.root:not([dir='rtl']) .day_range_start:not(.day_range_end) {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.root:not([dir='rtl']) .day_range_end:not(.day_range_start) {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.root[dir='rtl'] .day_range_start:not(.day_range_end) {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.root[dir='rtl'] .day_range_end:not(.day_range_start) {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.day_range_end.day_range_start {\n\tborder-radius: 100%;\n}\n\n.day_range_middle {\n\tborder-radius: 0;\n}\n\n\n/* ----------------------- Apply Centric Overrides Below ----------------------------- */\n.root {\n\t/* override */\n\t--rdp-cell-size: 40px;\n\t/* Size of the day cells. */\n\t--rdp-caption-font-size: 12px;\n\t/* Font size for the caption labels. */\n\t--rdp-accent-color: var(--Blue600);\n\t/* Accent color for the background of selected days. */\n\t--rdp-background-color: #e7edff;\n\t/* Background color for the hovered/focused elements. */\n\t--rdp-accent-color-dark: #3003e1;\n\t/* Accent color for the background of selected days (to use in dark-mode). */\n\t--rdp-background-color-dark: #180270;\n\t/* Background color for the hovered/focused elements (to use in dark-mode). */\n\t--rdp-outline: 2px solid var(--rdp-accent-color);\n\t/* Outline border for focused elements */\n\t--rdp-outline-selected: 3px solid var(--rdp-accent-color);\n\t/* Outline border for focused _and_ selected elements */\n\t--rdp-selected-color: #fff;\n\t/* Color of selected day text */\n\n\tmargin: 0;\n\n\tuser-select: none;\n}\n\n.day_range_start {\n\t/* override */\n\theight: calc(var(--rdp-cell-size) - 4px);\n}\n\n.day_range_middle {\n\t/* override */\n\tbackground: var(--Blue50);\n\theight: calc(var(--rdp-cell-size) - 4px);\n\tcolor: var(--PrimaryBlack);\n}\n\n.day_range_end {\n\t/* override */\n\theight: calc(var(--rdp-cell-size) - 4px);\n}\n\n.day_outside {\n\t/* override */\n\topacity: 0.3;\n}\n\n.root:not([dir='rtl']) .day_range_start:not(.day_range_end) {\n\t/* override */\n\tborder-top-left-radius: 20%;\n\tborder-bottom-left-radius: 20%;\n}\n\n.root:not([dir='rtl']) .day_range_end:not(.day_range_start) {\n\t/* override */\n\tborder-top-right-radius: 20%;\n\tborder-bottom-right-radius: 20%;\n}\n\n/* give caption horizontal padding */\n.caption {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 0;\n\ttext-align: left;\n\t/* override */\n\tpadding: 0 8px;\n}\n\n/* make nav buttons smaller */\n.nav {\n\twhite-space: nowrap;\n\t/* override */\n\ttransform: scale(0.5);\n\ttransform-origin: right;\n}\n\n/* ------------------- Apply style overrides to custom components below -------------- */\n.customComponentsTime {\n\tcursor: pointer;\n\tpadding-bottom: 2px;\n\tpadding-left: 4px;\n\tpadding-right: 1px;\n\tpadding-top: 2px;\n}\n\n.customComponentsDynamicDateButtons {\n\tjustify-content: flex-start;\n}\n\n.customComponentsDynamicDateButtonsSelected {\n\tbackground-color: var(--Blue50);\n}\n\n.customComponentsControlledTextField {\n\twidth: auto;\n}\n\n.customComponentsNumberOfDaysTextField {\n\twidth: 40px;\n}\n\n.customComponentsTimeDisabled {\n\tcolor: var(--Grey400);\n\tcursor: no-drop;\n}\n\n.customComponentsTimeBackground {\n\tbackground-color: var(--Grey100);\n}\n\n.customComponentsSelectedTime {\n\tbackground-color: var(--Blue600);\n\tborder-radius: 3px;\n\tcolor: var(--PrimaryWhite);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `designSystem-components-dateRange-DateRangeTimePicker-module-root`,
	"vhidden": `designSystem-components-dateRange-DateRangeTimePicker-module-vhidden`,
	"button_reset": `designSystem-components-dateRange-DateRangeTimePicker-module-button_reset`,
	"buttonReset": `designSystem-components-dateRange-DateRangeTimePicker-module-button_reset`,
	"focus-visible": `designSystem-components-dateRange-DateRangeTimePicker-module-focus-visible`,
	"focusVisible": `designSystem-components-dateRange-DateRangeTimePicker-module-focus-visible`,
	"button": `designSystem-components-dateRange-DateRangeTimePicker-module-button`,
	"day_selected": `designSystem-components-dateRange-DateRangeTimePicker-module-day_selected`,
	"daySelected": `designSystem-components-dateRange-DateRangeTimePicker-module-day_selected`,
	"months": `designSystem-components-dateRange-DateRangeTimePicker-module-months`,
	"month": `designSystem-components-dateRange-DateRangeTimePicker-module-month`,
	"table": `designSystem-components-dateRange-DateRangeTimePicker-module-table`,
	"with_weeknumber": `designSystem-components-dateRange-DateRangeTimePicker-module-with_weeknumber`,
	"withWeeknumber": `designSystem-components-dateRange-DateRangeTimePicker-module-with_weeknumber`,
	"caption": `designSystem-components-dateRange-DateRangeTimePicker-module-caption`,
	"multiple_months": `designSystem-components-dateRange-DateRangeTimePicker-module-multiple_months`,
	"multipleMonths": `designSystem-components-dateRange-DateRangeTimePicker-module-multiple_months`,
	"caption_dropdowns": `designSystem-components-dateRange-DateRangeTimePicker-module-caption_dropdowns`,
	"captionDropdowns": `designSystem-components-dateRange-DateRangeTimePicker-module-caption_dropdowns`,
	"caption_label": `designSystem-components-dateRange-DateRangeTimePicker-module-caption_label`,
	"captionLabel": `designSystem-components-dateRange-DateRangeTimePicker-module-caption_label`,
	"nav": `designSystem-components-dateRange-DateRangeTimePicker-module-nav`,
	"caption_start": `designSystem-components-dateRange-DateRangeTimePicker-module-caption_start`,
	"captionStart": `designSystem-components-dateRange-DateRangeTimePicker-module-caption_start`,
	"caption_end": `designSystem-components-dateRange-DateRangeTimePicker-module-caption_end`,
	"captionEnd": `designSystem-components-dateRange-DateRangeTimePicker-module-caption_end`,
	"nav_button": `designSystem-components-dateRange-DateRangeTimePicker-module-nav_button`,
	"navButton": `designSystem-components-dateRange-DateRangeTimePicker-module-nav_button`,
	"dropdown_year": `designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_year`,
	"dropdownYear": `designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_year`,
	"dropdown_month": `designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_month`,
	"dropdownMonth": `designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_month`,
	"dropdown": `designSystem-components-dateRange-DateRangeTimePicker-module-dropdown`,
	"dropdown_icon": `designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_icon`,
	"dropdownIcon": `designSystem-components-dateRange-DateRangeTimePicker-module-dropdown_icon`,
	"head": `designSystem-components-dateRange-DateRangeTimePicker-module-head`,
	"head_row": `designSystem-components-dateRange-DateRangeTimePicker-module-head_row`,
	"headRow": `designSystem-components-dateRange-DateRangeTimePicker-module-head_row`,
	"row": `designSystem-components-dateRange-DateRangeTimePicker-module-row`,
	"head_cell": `designSystem-components-dateRange-DateRangeTimePicker-module-head_cell`,
	"headCell": `designSystem-components-dateRange-DateRangeTimePicker-module-head_cell`,
	"tbody": `designSystem-components-dateRange-DateRangeTimePicker-module-tbody`,
	"tfoot": `designSystem-components-dateRange-DateRangeTimePicker-module-tfoot`,
	"cell": `designSystem-components-dateRange-DateRangeTimePicker-module-cell`,
	"weeknumber": `designSystem-components-dateRange-DateRangeTimePicker-module-weeknumber`,
	"day": `designSystem-components-dateRange-DateRangeTimePicker-module-day`,
	"day_today": `designSystem-components-dateRange-DateRangeTimePicker-module-day_today`,
	"dayToday": `designSystem-components-dateRange-DateRangeTimePicker-module-day_today`,
	"day_outside": `designSystem-components-dateRange-DateRangeTimePicker-module-day_outside`,
	"dayOutside": `designSystem-components-dateRange-DateRangeTimePicker-module-day_outside`,
	"day_range_start": `designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start`,
	"dayRangeStart": `designSystem-components-dateRange-DateRangeTimePicker-module-day_range_start`,
	"day_range_end": `designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end`,
	"dayRangeEnd": `designSystem-components-dateRange-DateRangeTimePicker-module-day_range_end`,
	"day_range_middle": `designSystem-components-dateRange-DateRangeTimePicker-module-day_range_middle`,
	"dayRangeMiddle": `designSystem-components-dateRange-DateRangeTimePicker-module-day_range_middle`,
	"customComponentsTime": `designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsTime`,
	"customComponentsDynamicDateButtons": `designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsDynamicDateButtons`,
	"customComponentsDynamicDateButtonsSelected": `designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsDynamicDateButtonsSelected`,
	"customComponentsControlledTextField": `designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsControlledTextField`,
	"customComponentsNumberOfDaysTextField": `designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsNumberOfDaysTextField`,
	"customComponentsTimeDisabled": `designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsTimeDisabled`,
	"customComponentsTimeBackground": `designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsTimeBackground`,
	"customComponentsSelectedTime": `designSystem-components-dateRange-DateRangeTimePicker-module-customComponentsSelectedTime`
};
module.exports = ___CSS_LOADER_EXPORT___;
